import axios from "axios";

const api = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL,
	withCredentials: true,
});

export const openApi = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL
});

// A fonte de verdade do token de acesso é esta variável em memória, não o
// localStorage diretamente. Em alguns navegadores/modos (ex: Safari em
// navegação privada), localStorage.setItem falha silenciosamente ou o valor
// não é lido de volta — a sessão fica válida na memória (React state, socket)
// mas todo request sai sem o header Authorization, derrubando o usuário.
// Guardando em memória, essa falha de storage deixa de quebrar a aba atual;
// o localStorage é só um "extra" pra lembrar a sessão entre recarregamentos.
let currentToken = null;
try {
	const stored = localStorage.getItem("token");
	if (stored) currentToken = JSON.parse(stored);
} catch (e) {
	// localStorage indisponível/bloqueado — segue sem token inicial
}

export const setToken = (token) => {
	currentToken = token || null;
	try {
		if (token) {
			localStorage.setItem("token", JSON.stringify(token));
		} else {
			localStorage.removeItem("token");
		}
	} catch (e) {
		// storage indisponível — a sessão da aba atual continua funcionando
		// via variável em memória mesmo assim
	}
};

export const getToken = () => currentToken;

// Interceptors registrados aqui, no carregamento do módulo — não dentro de um
// componente/hook React. Se ficassem em um useEffect do AuthProvider, o efeito
// dos componentes filhos (que também disparam suas próprias chamadas de API
// no mount) pode rodar ANTES do efeito do AuthProvider (React executa efeitos
// dos filhos antes dos pais), fazendo essas chamadas saírem sem o header
// Authorization. Registrando aqui, o interceptor já existe antes de qualquer
// componente montar.
api.interceptors.request.use(
	(config) => {
		if (currentToken) {
			config.headers["Authorization"] = `Bearer ${currentToken}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

api.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		const originalRequest = error.config;
		if (error?.response?.status === 403 && !originalRequest._retry) {
			originalRequest._retry = true;

			const { data } = await api.post("/auth/refresh_token");
			if (data) {
				setToken(data.token);
				api.defaults.headers.Authorization = `Bearer ${data.token}`;
			}
			return api(originalRequest);
		}
		if (error?.response?.status === 401) {
			setToken(null);
			api.defaults.headers.Authorization = undefined;
			window.dispatchEvent(new Event("auth:unauthorized"));
		}
		return Promise.reject(error);
	}
);

export default api;
